import React, { Component } from "react";
import { connect } from "react-redux";

import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { productHistoryModel_close } from "../../store/MaterialRequest/actions";
import moment from "moment";

class ProductHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.productHistory_model}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.productHistoryModel_close()}>
            Product History
          </ModalHeader>

          <ModalBody>
            <div
              className="table-responsive m-0"
              style={{
                maxHeight: "550px",
                overflowY: "auto",
              }}
            >
              <Table
                // striped
                bordered
                hover
                responsive
                className="mb-0 p-0 table-centered"
              >
                <thead className="bg-light text-center">
                  <tr>
                    <th className="nowrap">S.No</th>
                    <th className="nowrap">Qty / Units</th>
                    <th className="nowrap">location</th>
                    <th className="nowrap">Issue Code</th>
                    <th className="nowrap">Issue Date</th>
                    <th className="nowrap">Issue By</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.productHistorylist.length === 0 ? (
                    <>
                      <tr>
                        <td colspan="5" className="text-center">
                          <span className="font-size-18 text-danger">
                            Data not available
                          </span>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {this.props.productHistorylist.map((Item, key) => (
                        <tr key={key}>
                          <td className="text-center">{key + 1}</td>
                          <td className="text-center">
                            {Item.qty} {Item?.unit.name}
                          </td>
                          <td className="text-center">
                            {Item.materialissue.location.name}
                          </td>
                          <td className="text-center">
                            {
                              Item.materialissue.fcode
                              // ? Item.materialissue?.fcode
                              // : "***"
                            }
                          </td>
                          <td className="text-center">
                            {moment(Item.materialissue.date).format(
                              "DD-MM-YYYY"
                            )}
                          </td>
                          <td className="text-center">
                            {Item.materialissue.createdby.fullname}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { productHistory_model, productHistorylist } = state.Materialrequest;
  return {
    productHistory_model,
    productHistorylist,
  };
};

export default connect(mapStatetoProps, {
  productHistoryModel_close,
})(ProductHistory);
